<article class="mt-1">
  @if (dataTable()) {
    <div class="content-container">
      @if (gateways().length) {
        <div class="search">
          <app-search-input [resultCount]="filteredCount" [searchText]="filtereText" (onSearchChanged)="searchChanged($event)" tooltipText=""></app-search-input>
        </div>

        <div class="mt-1"></div>
        <app-data-table [dataTable]="dataTable()" dataTableKey="grafana:list" (onRowClick)="rowClick($event)" />
      } @else {
        No dashboards available.
      }
    </div>
  } @else {
    <app-please-wait />
  }

  <router-outlet></router-outlet>
</article>
